import React, { useEffect, useState } from "react";
import "./css/Banner.css";

const targetDateUTC = Date.UTC(2026, 11, 19, 4, 0, 0);

const getTimeRemaining = () => {
  const nowUTC = new Date().getTime();
  const total = targetDateUTC - nowUTC;

  const seconds = Math.floor((total / 1000) % 60);
  const minutes = Math.floor((total / 1000 / 60) % 60);
  const hours = Math.floor((total / (1000 * 60 * 60)) % 24);
  const days = Math.floor(total / (1000 * 60 * 60 * 24));

  return { total, days, hours, minutes, seconds };
};

const Countdown = () => {
  const [timeLeft, setTimeLeft] = useState(getTimeRemaining());

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(getTimeRemaining());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="banner-section">
      <div className="banner-overlay">
        <h1 className="gta-heading">Coming November 19 2026</h1>
        <div className="countdown-wrapper">
          <div className="countdown-box">
            <div>{timeLeft.days}</div>
            <div className="countdown-label">Days</div>
          </div>
          <div className="countdown-box">
            <div>{timeLeft.hours}</div>
            <div className="countdown-label">Hours</div>
          </div>
          <div className="countdown-box">
            <div>{timeLeft.minutes}</div>
            <div className="countdown-label">Minutes</div>
          </div>
          <div className="countdown-box">
            <div>{timeLeft.seconds}</div>
            <div className="countdown-label">Seconds</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Countdown;
